import type { I18nFn } from '#/i18n/types/I18nFn';

export function LISTING_FLAGGING_REASONS(i18n: I18nFn) {
  return [
    {
      id: 'MISSING_INFORMATION',
      description: i18n('I think something is missing, broken, or incorrect.'),
      secondaryDescription: i18n(
        'Ex: Application link is missing or location is incorrect',
      ),
    },
    {
      id: 'THIS_IS_A_SCAM_SPAM',
      description: i18n('I think this is a scam or spam.'),
    },
    {
      id: 'THIS_IS_ILLEGAL_INCITES_HATE',
      description: i18n(
        'I think this listing may be discriminatory or offensive',
      ),
      secondaryDescription: i18n(
        'Ex. Listing uses hate speech or discriminatory language.',
      ),
    },
    {
      id: 'INFORMATION_IS_OUT_OF_DATE',
      description: i18n('This listing is no longer accepting applications'),
    },
    {
      id: 'OTHER',
      description: i18n('Other'),
    },
  ];
}
